// A completed video is an independent viewing copy (TCA-26102602). Its URL
// survives gallery/session retirement, but not browser/app shutdown. No fetch.
export function openVideoSnapshot(blob, isCurrent) {
  if (!isCurrent() || !(blob instanceof Blob) || !blob.size) return 'retired';
  let popup;
  let url;
  let timer;
  let released = false;
  const release = () => {
    if (released) return;
    released = true;
    clearInterval(timer);
    if (url) URL.revokeObjectURL(url);
  };
  const abandon = () => {
    release();
    try { if (popup && !popup.closed) popup.close(); } catch { /* Already inaccessible. */ }
  };
  try {
    // Keep an observable handle for disposal; detach the opener synchronously.
    popup = window.open('', '_blank');
    if (!popup) return 'blocked';
    popup.opener = null;
    if (!isCurrent() || popup.closed) { abandon(); return 'retired'; }
    url = URL.createObjectURL(blob);
    if (!isCurrent()) { abandon(); return 'retired'; }
    popup.location.href = url;
    // Initial blob navigation must not revoke the URL through pagehide.
    // Navigation elsewhere conservatively retains it until this tab closes.
    timer = setInterval(() => {
      if (popup.closed) release();
    }, 1000);
    return 'opened';
  } catch {
    abandon();
    return 'failed';
  }
}
